<template>
    <!--<div :class="`tentacle tentacle_${this.num}`" :data-rotation="`${this.startingAngle}`" :id="`${this.tentacle_id}_tentacle_${this.num}`">-->
    <div :class="`tentacle tentacle_${this.num}`" :id="`${this.tentacle_id}_tentacle_${this.num}`" :style="style">
    </div>
</template>

<script>
// var TWEEN = require('@tweenjs/tween.js')
import TWEEN from '@tweenjs/tween.js'
import M from 'transformation-matrix-js'
import { EventBus } from '../EventBus.js'

export default {
  props: {
    num: {
      type: Number,
      required: true
    },
    tentacle_id: {
      type: Number,
      required: true
    },
    elNum: {
      type: Number,
      required: true
    },
    startingAngle: {
      type: Number,
      required: true
    }
  },
  data () {
    let style = {zIndex: this.num + this.tentacle_id * 10}
    return {
      angle: 0,
      elId: this.tentacle_id + '_tentacle_' + this.num,
      offset: 0,
      element: null,
      matrix: null,
      parentMatrix: null,
      parentId: null,
      childId: null,
      style: style
    }
  },
  mounted () {
    this.element = document.getElementById(this.elId)
    this.matrix = new M.Matrix()
    this.matrix.rotateDeg(this.startingAngle)
    this.parentMatrix = new M.Matrix()
    let prev = this.element.previousElementSibling
    if (prev) {
      this.parentId = prev.id
    }
    let next = this.element.nextElementSibling
    if (next) {
      this.childId = next.id
    }

    this.animate(this.elId)
    let i = 0
    let self = this.element
    if (self) {
      let child = self.previousElementSibling
      while (child != null) {
        i++
        child = child.previousSibling
      }
      this.offset = -64 * i

      if (i > 0) {
        this.matrix.translateY(-64)
      }
    }
  },
  methods: {
    animate (targetId) {
      // eslint-disable-next-line
      let frameHandler

      // Handles updating the tween on each frame.
      const animate = function (currentTime) {
        TWEEN.update(currentTime)
        frameHandler = requestAnimationFrame(animate)
      }

      let self = this
      let target = document.getElementById(targetId)
      let tw1 = new TWEEN.Tween({rotation: this.angle})
        .to({rotation: (Math.random() - 0.5) * 20 * (this.elNum + 1)}, Math.random() * 1500 + 1000)
        .repeat(Infinity)
        .yoyo(true)
        .easing(TWEEN.Easing.Sinusoidal.InOut)
        .onUpdate(function (object) {
          self.rotatePart(target, object)
        })

      tw1.start()

      frameHandler = requestAnimationFrame(animate)
    },
    rotatePart (box, params) {
      let delta = params.rotation - this.angle
      this.angle += delta
      this.matrix.rotateDeg(delta)

      EventBus.$emit('tentacle-part-rotated', { part: this })
    }
  }
}
</script>

<style>
.tentacle_holder {
    position: relative;
}

.tentacle {
    width: 100px;
    height: 72px;
    position: absolute;
    transform-origin: 50% 100%;
}

.tentacle_9 {
    background-image: url(../../static/img/tentacle_09.png);
}
.tentacle_8 {
    background-image: url(../../static/img/tentacle_08.png);
}
.tentacle_7 {
    background-image: url(../../static/img/tentacle_07.png);
}
.tentacle_6 {
    background-image: url(../../static/img/tentacle_06.png);
}
.tentacle_5 {
    background-image: url(../../static/img/tentacle_05.png);
}
.tentacle_4 {
    background-image: url(../../static/img/tentacle_04.png);
}
.tentacle_3 {
    background-image: url(../../static/img/tentacle_03.png);
}
.tentacle_2 {
    background-image: url(../../static/img/tentacle_02.png);
}
.tentacle_1 {
    background-image: url(../../static/img/tentacle_01.png);
}
.tentacle_0 {
    background-image: url(../../static/img/tentacle_00.png);
}
</style>



// WEBPACK FOOTER //
// src/components/TentaclePart.vue